import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import type { BlockThemeConfig, Service } from 'webapp-types';
import ThemeConfig from 'webapp/const/theme-config';
import { ChangeIndicatorClass } from 'webapp/enums/enums';

import type { Args as BaseArgs } from 'webapp/components/common/simple-line-chart';
import CommonSimpleLineChartComponent from 'webapp/components/common/simple-line-chart';

const metricThemeId = 6;

//  metric chart theme, match with @colorTheme6colors from functions.less
const theme6Colors = ['#25a767', '#00a5ff', '#e85a47'];

interface Args extends BaseArgs {
	indicatorClass?: ChangeIndicatorClass;
}

export default class MetricsChartComponent extends CommonSimpleLineChartComponent<Args> {
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('constants') declare constantsService: Service.Constants;
	@service('navigation') declare navigationService: Service.Navigation;

	@cached
	get themeData() {
		const color = this.navigationService.theme.isDark
			? this.constantsService.defaultBoardColor
			: '#ffffff';

		// themeId 6 is the metric chart theme (w/ just green, red and blue)
		const colorConfigBase = this.mmBoardsService.getColorConfig(color, metricThemeId);

		const colorConfig: BlockThemeConfig.BlockParsed = Object.assign({}, colorConfigBase, {
			visualizationConfig: this.args.visualization.getBlockThemeConfigContent(
				ThemeConfig[0]!.visualizations,
			),
			colors: theme6Colors,
		});

		return colorConfig;
	}

	@cached
	get colorIndex() {
		// from @colorTheme6colors from functions.less match index (positive, neutral, negative)
		switch (this.args.indicatorClass) {
			case ChangeIndicatorClass.POSITIVE:
				return 0;
			case ChangeIndicatorClass.NEGATIVE:
				return 2;
			default:
				return 1;
		}
	}

	updateSeriesColorIndex() {
		const colorIndex = this.colorIndex;
		this.args.visualization.series.forEach((s) => {
			s.colorIndexOrClass = colorIndex;
			s.points.forEach((p) => {
				p.colorIndexOrClass = colorIndex;
			});
		});
	}

	protected override updateDataCache() {
		super.updateDataCache();
		this.updateSeriesColorIndex();
	}
}
